module.exports = __webpack_public_path__ + "media/images/star_outline_icon-5c3655e8.png";